import { RulerUpdateDetails } from "../maplayers/ruler-layer";
import { NearestPortModelBase, NearestPortPosition, NearestPortHighlights, NearestPortEvents } from "./nearest-port-model";

export class NearestPortModelImpl extends NearestPortModelBase {
    constructor() {
        super();

        this.updateRuler = this.updateRuler.bind(this);
    }

    updateRuler(detail: RulerUpdateDetails): void {
        this.dispatchEvent(new CustomEvent(NearestPortEvents.Ruler, { detail }));
    }

    setPortHighLight(detail: NearestPortHighlights) {
        this.dispatchEvent(new CustomEvent(NearestPortEvents.PortHighlightChange, { detail }));
    }

    setDropPin(detail: NearestPortPosition) {
        this.dispatchEvent(new CustomEvent(NearestPortEvents.DropPin, { detail }));
    }
}
